var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricalUtilities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11C18.2044 11 17.4413 11.3161 16.8787 11.8787C16.3161 12.4413 16 13.2044 16 14V16H22V14C22 13.2044 21.6839 12.4413 21.1213 11.8787C20.5587 11.3161 19.7956 11 19 11ZM15.4645 10.4645C16.4021 9.52678 17.6739 9 19 9C20.3261 9 21.5979 9.52678 22.5355 10.4645C23.4732 11.4021 24 12.6739 24 14V17C24 17.5523 23.5523 18 23 18H15C14.4477 18 14 17.5523 14 17V14C14 12.6739 14.5268 11.4021 15.4645 10.4645Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 16C17.5523 16 18 16.4477 18 17V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V17C16 16.4477 16.4477 16 17 16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 16C21.5523 16 22 16.4477 22 17V20C22 20.5523 21.5523 21 21 21C20.4477 21 20 20.5523 20 20V17C20 16.4477 20.4477 16 21 16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1C5 0.447715 5.44772 0 6 0H19C19.5523 0 20 0.447715 20 1V10C20 10.5523 19.5523 11 19 11C18.4477 11 18 10.5523 18 10V2H7V4C7 4.55228 6.55228 5 6 5C5.44772 5 5 4.55228 5 4V1Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585786 6.58579C0.960859 6.21071 1.46957 6 2 6H10C10.5304 6 11.0391 6.21071 11.4142 6.58579C11.7893 6.96086 12 7.46957 12 8V21C12 21.5304 11.7893 22.0391 11.4142 22.4142C11.0391 22.7893 10.5304 23 10 23H2C1.46957 23 0.960861 22.7893 0.585786 22.4142C0.210713 22.0391 0 21.5304 0 21V8C0 7.46957 0.210714 6.96086 0.585786 6.58579ZM10 8L2 8V21H10V8Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalUtilities);
export default __webpack_public_path__ + "static/media/electrical_utilities.190967f9f2cf6d488ff1c181d121dc93.svg";
export { ForwardRef as ReactComponent };